import { render } from "./StoreHours.vue?vue&type=template&id=db8e3ca8&ts=true"
import script from "./StoreHours.vue?vue&type=script&lang=ts"
export * from "./StoreHours.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__